export default __webpack_public_path__ + "static/media/MP3.452aeaac.png";